import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTouchedOnKeyUp]',
})
export class TouchedOnKeyUpDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('keyup')
  public onKeyup(): void {
    if (this.ngControl.control) {
      this.ngControl.control.markAsTouched();
    }
  }
}
